<template>
  <div class="gd-context">
    <div class="gd-context-item">
      <small>Paciente</small>
      <div>{{ patient || '-' }}</div>
    </div>
    <div class="gd-context-item">
      <small>Convênio</small>
      <div>{{ insurance || '-' }}</div>
    </div>
    <div class="gd-context-item">
      <small>Profissional executante</small>
      <div>
        {{ professional || '-' }}
        <span class="gd-context-detail" v-if="professionalDetail">· {{ professionalDetail }}</span>
      </div>
    </div>
    <div class="gd-context-item compact">
      <small>Atendimento</small>
      <div>{{ startDate ? $options.filters.date(startDate, 'datetime') : '-' }}</div>
    </div>
    <div class="gd-context-item status" v-if="status">
      <guide-status-badge :status="status" :batch-number="batchNumber"/>
    </div>
  </div>
</template>

<script>
import GuideStatusBadge from './GuideStatusBadge.vue';

export default {
  components: {
    GuideStatusBadge,
  },
  props: {
    patient: {
      type: String,
      default: '',
    },
    insurance: {
      type: String,
      default: '',
    },
    professional: {
      type: String,
      default: '',
    },
    professionalDetail: {
      type: String,
      default: '',
    },
    startDate: {
      type: [String, Date],
      default: null,
    },
    status: {
      type: String,
      default: null,
    },
    batchNumber: {
      type: [String, Number],
      default: null,
    },
    referralNumber: {
      type: String,
      default: null,
    },
  },
};
</script>
